import React, { useEffect, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import YogaRecordForm from '../../components/Records/Yoga/YogaRecordForm';
import * as RecordActions from '../../actions/Records/actions';
import * as UserActions from '../../actions/User/actions';
import { RootState } from '../../store/configureStore';
import Loading from '../../components/common/Loading';
import { YogaRecord } from '../../constants/Records';

interface RouteParams {
  institutionId: string;
  userId: string;
}

interface StateProps {
  institution: any;
  userListData: any[];
  yoga: any;
  yogaMenus: any[];
}

interface DispatchProps {
  recordActions: typeof RecordActions;
  userActions: typeof UserActions;
}

type Props = StateProps & DispatchProps;

const YogaRecordCreateContainer: React.FC<Props> = ({
  institution,
  userListData,
  yoga,
  yogaMenus,
  recordActions,
  userActions,
}) => {
  const { institutionId, userId } = useParams<RouteParams>();
  const initializedRef = useRef(false);
  const userFetchedRef = useRef(false);

  const user = userListData.find((u: any) => u.user_id === userId);
  const uniqueId = user?.unique_id;

  // ユーザーデータがない場合は取得
  useEffect(() => {
    if (userListData.length === 0 && !userFetchedRef.current && institutionId) {
      userFetchedRef.current = true;
      userActions.getUsersWithUniqueId(institutionId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [institutionId, userListData.length]);

  // 初期メニュー取得（一度だけ実行）
  useEffect(() => {
    if (uniqueId && !initializedRef.current) {
      initializedRef.current = true;
      recordActions.fetchYogaRecords(uniqueId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqueId]);

  const handleFetchMenus = useCallback(
    (id: string) => {
      recordActions.fetchYogaRecords(id);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleCreate = useCallback(
    (data: Partial<YogaRecord>) => {
      recordActions.createYogaRecord(data);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleResetFlags = useCallback(() => {
    recordActions.resetYogaFlags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!user) {
    return <Loading />;
  }

  return (
    <YogaRecordForm
      institutionId={institutionId}
      institutionName={institution?.institution_name || ''}
      userId={userId}
      userName={user.user_name}
      uniqueId={user.unique_id || ''}
      menus={yogaMenus}
      currentRecord={null}
      isEdit={false}
      executing={yoga.executing}
      created={yoga.created}
      updated={yoga.updated}
      onFetchRecord={() => {}}
      onFetchMenus={handleFetchMenus}
      onCreate={handleCreate}
      onUpdate={() => {}}
      onResetFlags={handleResetFlags}
    />
  );
};

function mapStateToProps(state: RootState): StateProps {
  return {
    institution: state.institution.institution,
    userListData: state.user.listData,
    yoga: state.records.yoga,
    yogaMenus: state.records.yogaMenus,
  };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
  return {
    recordActions: bindActionCreators(RecordActions, dispatch),
    userActions: bindActionCreators(UserActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(YogaRecordCreateContainer);
